import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { OfficeSelectorService } from 'src/app/common/officeSelector/officeSelector.service';
import { NoveltyService } from '../../services/novelty.service';
import { ModalDialogComponent } from 'src/app/common/modal/modalDialog.component';
import { NoveltyModel, NoveltyUserModel } from '../../models/novelty.model';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';

@Component({
    selector: 'app-novelty-user',
    templateUrl: './novelty-user.component.html',
    styleUrls: ['./novelty-user.component.css'],
    standalone: false
})
export class NoveltyUserComponent implements OnInit {

  @ViewChild(ModalDialogComponent, { static: true }) private noveltiesDialog: ModalDialogComponent;

  private selectedUserSubscription: Subscription;

  public loading = false;
  public novelties: NoveltyModel[];

  // Mensajes
  private timeout: any;
  message = {
    show: false,
    type: '',
    body: ''
  };

  constructor(
    private apigeeService: ApigeeService,
    private officeSelectorService: OfficeSelectorService,
    private noveltyService: NoveltyService) { }

  ngOnInit() {
    this.selectedUserSubscription = this.apigeeService.authInfoUserUpdated.subscribe(() => {
      this.initializeData();
    });
  }

  ngAfterViewInit(): void {
    this.noveltiesDialog.acceptEvent.subscribe(() => {
      this.saveViewNoveltiesUser();
    });
  }

  ngOnDestroy(): void {
    if (this.noveltiesDialog.acceptEvent) {
      this.noveltiesDialog.acceptEvent.unsubscribe();
    }
    if (this.selectedUserSubscription) {
      this.selectedUserSubscription.unsubscribe();
    }
  }

  /**
   * Inicializa la data para mostrar en la modal
   */
  initializeData(): void {
    if (this.apigeeService.hasToken) {
      this.officeSelectorService.getOfficeList(this.apigeeService.userInfo.nameid).then(companiesOffice => {
        const companies = companiesOffice.map(x => x.id);
        this.getNovelties(companies);
      });
    }
  }

  /**
   * Consulta las novedades de una compañía
   * @param companyIds Identificadores de compañía
   */
  getNovelties(companyIds: string[]): void {
    this.loading = true;

    this.noveltyService.getByCompanies(companyIds).subscribe(data => {
      this.novelties = data.novelties.sort((a, b) => moment(b.iDate).valueOf() - moment(a.iDate).valueOf());;

      if (this.novelties.length > 0) {
        this.noveltiesDialog.open();
      }

      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  /**
   * Guarda las novedades visualizadas por un usuario
   */
  saveViewNoveltiesUser(): void {
    this.loading = true;
    const noveltIds = this.novelties.map(({ noveltyId }) => noveltyId);

    const noveltyUser: NoveltyUserModel = {
      noveltyIds: noveltIds
    };

    this.noveltyService.saveViewUser(noveltyUser).subscribe(data => {
      this.loading = false;
      this.noveltiesDialog.close(null);
    }, () => {
      this.loading = false;
      this.showMessage('danger', 'Ha ocurrido un error al intentar guardar la visualización de las novedades.');
    });
  }

  /**
   * Obtiene la url del fichero cargado a S3 para una novedad
   * @param noveltyId Identificador de la novedad
   */
  downloadAttachment(noveltyId: number): void {
    this.loading = true;

    this.noveltyService.getUrlAttachment(noveltyId).subscribe(data => {
      this.loading = false;
      window.open(data.urlAttachment, '_blank');
    }, () => {
      this.loading = false;
    });
  }

  /**
  * Muestra mensaje en pantalla
  * @param type tipo de mensaje (danger, success, info, warning)
  * @param body contenido del mensaje a mostrar
  */
  showMessage(type: string, body: string): void {
    this.message = {
      show: true,
      body: body,
      type: type
    };
    window.scroll(0, 0);

    // Limpia el mensaje después de 5 segundos
    window.clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.clearMessage();
    }, 5000);

  }

  /**
   * Limpia los mensajes de pantalla
   */
  clearMessage(): void {
    this.message = {
      show: false,
      body: '',
      type: ''
    };
  }

}
